import { SelectItem } from 'primeng/api';
import { Prescriptions } from './prescription';
import { OtpData, OTP_Validate } from "./util.models";
export class appointmentGetQuery {
    user_guid: string;
    self: boolean;
    fromtime: Date;
    totime: Date;
    consultation_status?: APPT_STATUS;
}

export class getPatientTimingsQuery {
    user_guid: string;
    patient_guid: string;
    consultation_id: number;
}

export class appointmentCreate {
    patient_guid: string;
    user_guid: string;
    consultation_id: number;
    fromtime: Date;
    totime: Date;
}
export class consent_close
{
    close_consent: boolean;
}
export class appointmentUpdate {
    patient_guid: string;
    user_guid: string;
    appointment_id: number;
    consultation_id: number;
    fromtime: Date;
    totime: Date;
    reason: string;
}


export class Appointment_close_otp {
    patient_guid: string;
    consultation_id: number;
}

export class AppointmentInitiate {
    patient_guid: string;
    consultation_id: number;
    shouldNotify?: boolean;
}

export class AppointmentZoom {
    patient_guid: string;
    consultation_id: number;
}

export class AppointmentClose {
    patient_guid: string = '';
    consultation_id: number = null;
    slot_id: number = null
    is_closed: boolean = null;
    consultation_notes: string = '';
    history_of_current_illness: string = '';
    issues: string = '';
    prescriptions: Prescriptions[] = [];
    referred_to_specialty_id: number = null;
    sign: string = '';
    patient_joined: boolean = null;
    close_otp_checkbox: boolean = false;
    close_otp: string = '';
    otp_model: {
        token: string,
        service_id: string
    }
}

export class AssignDoctorModel {
    // user_guid: string;
    // current_user_guid: string;
    // patient_guid: string;
    // consultation_id: number;
    // schedule_id: number;
    patient_guid: string;
    consultation_id: number;
    slot_id: number;
    user_guid: string[];
    shouldNotify?: boolean = true;
}

export class ReassignDoctorModel {
    // user_guid: string;
    // current_user_guid: string;
    // patient_guid: string;
    // consultation_id: number;
    // schedule_id: number;
    // reassign_reason: string;
    patient_guid: string;
    consultation_id: number;
    slot_id: number;
    user_guid: string[];
    reassign_reason: string;
    shouldNotify?: boolean = true;
}

export class RescheduleDoctorModel {
    // current_user_guid:string;
    patient_guid: string;
    consultation_id: number;
    slot_id: number;
    reason: string;
    shouldNotify?: boolean = true;
}

export class CosnultationDataQuery {
    user_guid: string;
    patient_guid: string;
    consultation_id: number;
}
export class updateSpeciality {
    consultation_id: number;
    patient_guid: string;
    specialty_id: number[];
}

export class AppointmentHistory {
    consultation: {
        consultation_request_number: string;
        created_at: Date;
        consultation_status: string;
        consultation_date: Date;
        accounts: {
            first_name: string;
            middle_name: string;
            last_name: string;
            medical_record_number: string;
        };
    };
    appointments: {
        status: number;
        reason: string;
        created_at: Date;
        updated_at: Date;
        egd_appointments: {
            user_guid: string;
            egd_users: {
                first_name: string;
                middle_name: string;
                last_name: string;
            };
            schedule: {
                slot_id: number;
                slot: {
                    slot_time: Date;
                };
            };
        }[];
    }[];
}

export class CosnultationHistoryDataQuery {
    user_guid: string;
    patient_guid: string;
    consultation_id: number;
}

export class GetAvailableDoctorsData {
    patient_guid: string;
    consultation_id: number;
    slot_id: number;
}

export class Sort_Data {
    sort_options: SelectItem[] = [];
    sort_selected: string = '';
    constructor(sort_options: SelectItem[], sort_selected: string) {
        this.sort_options = sort_options;
        this.sort_selected = sort_selected;
    }
}

export enum APPT_STATUS {
    scheduled = 'SCHEDULED',
    inprogress = 'IN PROGRESS',
    closed = 'CLOSED'
}
